(function () {
  "use strict";

  var EXPECTED_LIVE_THEME_ID = "203036688729";
  var CHECK_INTERVAL_MS = 30000;

  var primaryHosts = [
    "trundes.com",
    "www.trundes.com",
    "389d16-2.myshopify.com"
  ];

  var checking = false;
  var lastCheck = 0;
  var runtimeLoading = null;

  function readMeta(name) {
    var element = document.querySelector(
      'meta[name="' + name + '"]'
    );

    return element
      ? String(element.getAttribute("content") || "")
      : "";
  }

  function currentThemeId() {
    var liquidThemeId = readMeta("tr-live-theme-id");

    if (liquidThemeId) {
      return liquidThemeId;
    }

    try {
      if (
        window.Shopify &&
        window.Shopify.theme &&
        window.Shopify.theme.id
      ) {
        return String(window.Shopify.theme.id);
      }
    } catch (error) {}

    return "";
  }

  function currentBuild() {
    return readMeta("tr-live-build");
  }

  function isPrimaryStorefront() {
    return primaryHosts.indexOf(
      window.location.hostname
    ) !== -1;
  }

  function shouldBypassGuard() {
    if (
      /\.shopifypreview\.com$/i.test(
        window.location.hostname
      )
    ) {
      return true;
    }

    if (
      /^(localhost|127\.0\.0\.1)$/i.test(
        window.location.hostname
      )
    ) {
      return true;
    }

    try {
      if (
        window.Shopify &&
        window.Shopify.designMode
      ) {
        return true;
      }
    } catch (error) {}

    return false;
  }

  function removeGuardParameters(url) {
    [
      "preview_theme_id",
      "_fd",
      "_sc",
      "_ab",
      "pb",
      "__tr_live",
      "__tr_fresh",
      "__tr_document"
    ].forEach(function (parameter) {
      url.searchParams.delete(parameter);
    });

    return url;
  }

  function cleanAddressBar() {
    var url = new URL(window.location.href);
    var before = url.toString();

    removeGuardParameters(url);

    if (before !== url.toString()) {
      try {
        window.history.replaceState(
          window.history.state,
          "",
          url.pathname +
            (url.search || "") +
            (url.hash || "")
        );
      } catch (error) {}
    }
  }

  function parseBeacon(html) {
    var documentCopy = new DOMParser().parseFromString(
      html,
      "text/html"
    );

    var beacon = documentCopy.querySelector(
      "[data-tr-live-beacon]"
    );

    if (!beacon) {
      throw new Error("Live beacon was not returned.");
    }

    return {
      themeId: String(
        beacon.getAttribute("data-theme-id") || ""
      ),
      role: String(
        beacon.getAttribute("data-theme-role") || ""
      ),
      build: String(
        beacon.getAttribute("data-build") || ""
      ),
      runtimeVersion: String(
        beacon.getAttribute(
          "data-cart-runtime-version"
        ) || ""
      ),
      runtimeUrl: String(
        beacon.getAttribute(
          "data-cart-runtime-url"
        ) || ""
      )
    };
  }

  function currentRuntimeVersion() {
    try {
      if (
        window.TrundesCartRuntime &&
        window.TrundesCartRuntime.version
      ) {
        return String(
          window.TrundesCartRuntime.version
        );
      }
    } catch (error) {}

    return "";
  }

  function runtimeIsBusy() {
    try {
      return Boolean(
        window.TrundesCartRuntime &&
        typeof window.TrundesCartRuntime.isBusy ===
          "function" &&
        window.TrundesCartRuntime.isBusy()
      );
    } catch (error) {
      return false;
    }
  }

  function loadRuntimeScript(version, url) {
    if (runtimeLoading) {
      return runtimeLoading;
    }

    runtimeLoading = new Promise(function (
      resolve,
      reject
    ) {
      var script = document.createElement("script");
      var timeoutId = window.setTimeout(
        function () {
          script.remove();
          reject(
            new Error(
              "Cart runtime update timed out."
            )
          );
        },
        10000
      );

      script.src = url;
      script.async = true;
      script.dataset.trCartRuntimeScript = version;
      script.dataset.trCartRuntimeDynamic = "true";
      script.onload = function () {
        window.clearTimeout(timeoutId);

        var runtime =
          window.TrundesCartRuntime;

        if (
          !runtime ||
          String(runtime.version || "") !== version
        ) {
          reject(
            new Error(
              "Cart runtime update returned the wrong version."
            )
          );
          return;
        }

        if (typeof runtime.install === "function") {
          runtime.install();
        }

        resolve(runtime);
      };
      script.onerror = function () {
        window.clearTimeout(timeoutId);
        script.remove();
        reject(
          new Error(
            "Cart runtime update could not be loaded."
          )
        );
      };

      document.head.appendChild(script);
    }).finally(function () {
      runtimeLoading = null;
    });

    return runtimeLoading;
  }

  async function updateCartRuntime(beacon) {
    if (
      !beacon.runtimeVersion ||
      !beacon.runtimeUrl ||
      currentRuntimeVersion() === beacon.runtimeVersion ||
      runtimeIsBusy()
    ) {
      return;
    }

    await loadRuntimeScript(
      beacon.runtimeVersion,
      beacon.runtimeUrl
    );
  }

  async function fetchLiveBeacon() {
    var root = "/";

    try {
      if (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) {
        root = window.Shopify.routes.root;
      }
    } catch (error) {}

    var url = new URL(root, window.location.origin);

    url.searchParams.set(
      "section_id",
      "tr-live-beacon"
    );

    url.searchParams.set(
      "__tr_fresh",
      String(Date.now())
    );

    var response = await fetch(url.toString(), {
      method: "GET",
      credentials: "omit",
      cache: "no-store",
      redirect: "follow",
      headers: {
        Accept: "text/html",
        "Cache-Control": "no-cache",
        Pragma: "no-cache"
      }
    });

    if (!response.ok) {
      throw new Error(
        "Live beacon request failed: " +
          response.status
      );
    }

    return parseBeacon(await response.text());
  }

  async function checkFreshness(force) {
    if (
      checking ||
      !isPrimaryStorefront() ||
      shouldBypassGuard()
    ) {
      return;
    }

    var now = Date.now();

    if (
      !force &&
      now - lastCheck < CHECK_INTERVAL_MS
    ) {
      return;
    }

    checking = true;
    lastCheck = now;

    try {
      var beacon = await fetchLiveBeacon();

      /*
       * Nur handeln, wenn der cookie-freie Request eindeutig
       * das veröffentlichte Theme zurückgibt.
       */
      if (
        beacon.themeId !== EXPECTED_LIVE_THEME_ID ||
        beacon.role.toLowerCase() !== "main" ||
        !beacon.build
      ) {
        return;
      }

      await updateCartRuntime(beacon);

      var localThemeId = currentThemeId();
      var localBuild = currentBuild();
      if (
        localThemeId === beacon.themeId &&
        localBuild === beacon.build
      ) {
        cleanAddressBar();
        return;
      }

      /*
       * Nur melden: Der Guard darf den aktuellen Seitenzustand
       * niemals durch Navigation oder Dokumentersatz unterbrechen.
       */
      console.warn(
        "[Trundes live guard] Stale storefront build detected.",
        {
          currentThemeId: localThemeId,
          currentBuild: localBuild,
          liveThemeId: beacon.themeId,
          liveBuild: beacon.build
        }
      );
    } catch (error) {
      /*
       * Bei Netzwerkproblemen wird niemals eine Endlosschleife
       * oder eine kaputte Seite erzeugt.
       */
      try {
        console.warn(
          "[Trundes live guard]",
          error
        );
      } catch (ignoredError) {}
    } finally {
      checking = false;
    }
  }

  window.addEventListener(
    "pageshow",
    function () {
      checkFreshness(true);
    }
  );

  document.addEventListener(
    "visibilitychange",
    function () {
      if (!document.hidden) {
        checkFreshness(false);
      }
    }
  );

  window.setTimeout(function () {
    checkFreshness(true);
  }, 0);

  window.setInterval(function () {
    checkFreshness(false);
  }, CHECK_INTERVAL_MS);
})();
